
export default function pluralize(label = '', val = 0) {
	if (val == undefined) return label
	if (val == 1) return `${val} ${label}`
	return `${val} ${label}s`
}

